import * as yup from "yup";


export const emailValidation = yup.string().required("Email is required").email("Invalid email address")
export const passwordValidationsignup = yup
.string()
.matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character'
)
.required('Please enter a password');


export const passwordValidation = yup.string().required("Please enter a password")
export const firstNameValidation = yup.string().required("First name is required")
export const lastNameValidation = yup.string().required("Last name is required")
export const countryValidation = yup.string().required("Country is required")
export const genderValidation = yup.string().required("Gender is required")
export const termsValidation = yup.string().required('You must agree to the terms')